import { render, staticRenderFns } from "./tblcomponents.vue?vue&type=template&id=768742df&"
import script from "./tblcomponents.vue?vue&type=script&lang=js&"
export * from "./tblcomponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports